export const mixin_1 = {
    data() {
        return {
            // 分页的props
            pageStart: 1, //  页码
            pageCount: 0, //  总条数
            pageTotal: this.$COMMON.pageTotals, //  一页几条
            // 自定义表头props
            originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
            show_sortTableHeard: false, //显示表格设置弹窗
            allCheck: false, //  全选
            selectLength: 0, //  显示的长度
            totalArr: [],
            className: "", //  导出需要
            selectTableData: [],
            defaultFormfield: {}
        }
    },
    methods: {
        // 按钮回调
        callBack(payload) {
            this[payload]();
        },
        // 查询事件
        queryBtn_ok() {
            this.GetData();
        },
        // 分页的方法
        handleSizeChange(val) {
            this.pageTotal = val;
            this.GetData();
        },
        handleCurrentChange(val) {
            this.pageStart = val;
            this.GetData();
        },
        // 时间组件 选择时间后触发
        queryBtn_time(s, e) {
            this.startTime_a = s || "";
            this.endTime_a = e || "";
            // this.queryBtn_ok()
        },
        timestatus(type, s, e) {
            this.timeType = type || "0";
            this.startTime_a = s || "";
            this.endTime_a = e || "";
        },

        // ==========排序表头的组件方法==========
        //   取消按钮(表格设置)
        cancelSortHeard() {
            this.show_sortTableHeard = false;
            this.$nextTick(() => {
                this.$refs.mytable.$refs.tables.doLayout();
            });
        },
        // 排序==>确认按钮(表格设置)
        confirmOk(e) {
            this.tabelHeadeTitle = e;
            this.myTableHeard = this.tabelHeadeTitle;
            let sortObject = this.myTableHeard;
            let param = {
                groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
                sortName: this.sortName, //综合查询接口路径 
                sortObject: JSON.stringify(sortObject),
            };
            this.$API.pushFindFieldSort(param).then((res) => {
                this.$message.success(res.data.message || "操作成功");
                //获取默认表头
                this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
            });
            this.show_sortTableHeard = false; //关闭弹窗
            this.$nextTick(() => {
                this.$refs.mytable.$refs.tables.doLayout();
            });
            this.show_sortTableHeard = false;
        },
        // 点击某一项(表格设置)
        checktab(idx, e) {
            let that = this;
            that.tabelHeadeTitle[idx].isShow = e;
            let selectLength = 0;
            for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
                if (that.tabelHeadeTitle[i].isShow) {
                    selectLength++;
                }
            }
            that.selectLength = selectLength;
            if (selectLength == that.tabelHeadeTitle.length) {
                that.allCheck = true;
            } else {
                that.allCheck = false;
            }
        },
        //全选(表格设置)
        checkAll(e) {
            let that = this;
            this.allCheck = e;
            for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
                this.tabelHeadeTitle[j].isShow = e;
            }
            let selectLength = 0;
            for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
                if (that.tabelHeadeTitle[i].isShow) {
                    selectLength++;
                }
            }
            that.selectLength = selectLength;
        },
        //关闭弹窗(表格设置)
        closeDias(e) {
            this.show_sortTableHeard = e;
        },
        // 设置表格高度
        fetTableHeight() {
            // 重置table高度
            this.tabelHeigth = 0;
            // 设置table高度
            let windonHeight =
                document.body.clientHeight || document.documentElement.clientHeight; //页面高度
            let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
            let btnListHeight = this.$refs.btnList.$el.offsetHeight; // 按钮列表高度
            if (this.isHaseMore) {
                queryHeigth = this.$refs.queryForm.$el.offsetHeight + 10; //查询框
            }

            let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
            var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
            let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //
            this.$nextTick(() => {
                this.tableConfig.tableHeigth = tabHeight;
                this.$refs.mytable.$refs.tables.doLayout();
            });
        },


    },
    created() {
        this.myTableHeard = this.tabelHeadeTitle;
        if (this.originalTabelHeadeTitle.length === 0) {
            this.originalTabelHeadeTitle = JSON.parse(
                JSON.stringify(this.tabelHeadeTitle)
            );
        }
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
    }
}